// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.AttributeTable {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
}

div.attribtable-overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(200, 200, 200);
    z-index: 4;
}

div.attribtable-overlay > div.spinner {
    width: 4em;
    height: 4em;
    margin-right: 1em;
}

div.attribtable-toolbar {
    display: flex;
    align-items: center;
    margin-bottom: 0.125em;
}

div.attribtable-toolbar > * {
    margin: 0.125em;
}

div.attribtable-contents {
    flex: 1 1 auto;
    background-color: var(--list-bg-color);
    overflow: auto;
    border: 1px solid var(--border-color);
    position: relative;
}

table.attribtable-table {
    min-width: 100%;
}

table.attribtable-table th {
    position: sticky;
    top: 0;
    z-index: 2;
    padding: 0;
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    box-shadow: inset -1px 0 0 var(--border-color),
                inset 0 -1px 0 var(--border-color);
    overflow: hidden;
}

table.attribtable-table th:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
    width: 2em;
}

table.attribtable-table th > span {
    margin: 0 0 -1px -1px;
    padding: 0.25em;
    display: flex;
    align-items: center;
    position: relative;
}

table.attribtable-table th > span > span.icon {
    position: absolute;
    right: 1px;
    background-color: var(--button-bg-color);
    flex: 0 0 auto;
    margin-left: 0.5em;
}

span.attribtable-table-headername {
    flex: 1 1 auto;
    text-align: left;
    display: flex;
    align-items: center;
}

table.attribtable-table tr:nth-child(even) {
    background-color: var(--list-item-bg-color-even);
}

table.attribtable-table tr:hover:not(.row-disabled) {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

table.attribtable-table td:first-child {
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    align-items: center;
    padding: 0.25em 0.5em;
    background-clip: padding-box;
    position: sticky;
    left: 0;
    z-index: 1;
    width: 2.5em;
}

span.attribtable-table-ldraghandle,
span.attribtable-table-rdraghandle {
    touch-action: none;
    display: block;
    position: absolute;
    width: 4px;
    top: 0;
    bottom: 0;
    cursor: ew-resize;
}

span.attribtable-table-ldraghandle {
    left: -1px;
}

span.attribtable-table-rdraghandle {
    right: 0px;
}

span.attribtable-table-tdraghandle,
span.attribtable-table-bdraghandle {
    touch-action: none;
    display: block;
    position: absolute;
    height: 4px;
    left: 0;
    right: 0;
    cursor: ns-resize;
}

span.attribtable-table-tdraghandle {
    top: -1px;
}

span.attribtable-table-bdraghandle {
    bottom: 0px;
}

table.attribtable-table {
    table-layout: fixed;
    width: 100%;
}

table.attribtable-table td {
    border: 1px solid var(--border-color);
    text-align: center;
    height: 2em;
}

table.attribtable-table td:first-child {
    border-left-width: 0;
}

table.attribtable-table td > input:not([type=checkbox]),
table.attribtable-table td > select,
table.attribtable-table td > div.TextInput,
table.attribtable-table td > div.number-input,
table.attribtable-table td > div.edit-multi-select,
table.attribtable-table td > span.edit-upload-field,
table.attribtable-table td > span.edit-upload-field-input {
    min-width: 100%;
    width: 0;
    border: none!important;
    background-color: transparent!important;
    margin: 0;
    height: 100%;
}

table.attribtable-table td > div.TextInput,
table.attribtable-table td > div.TextInput > pre {
    min-height: 2em;
}

table.attribtable-table tr.row-disabled td > *:disabled,
table.attribtable-table tr.row-disabled,
table.attribtable-table tr.row-disabled * {
    color: var(--text-color-disabled);
    cursor: not-allowed!important;
}

div.attribtable-footbar {
    display: flex;
    align-items: center;
    margin: 0 -0.25em;
    flex-wrap: wrap;
}

div.attribtable-footbar > div {
    margin: 0.25em;
}

div.attribtable-filter {
    flex: 1 1 auto;
}

div.attribtable-filter .attribtable-filter-value {
    flex: 1 1 auto;
    min-width: 5em;
    max-width: 15em;
}

body.ewresizing, body.ewresizing * {
    cursor: ew-resize!important;
    user-select: none;
}

body.nsresizing, body.nsresizing * {
    cursor: ns-resize!important;
    user-select: none;
}

div.attribtable-resize-line-vert,
div.attribtable-resize-line-horiz {
    position: absolute;
    z-index: 2;
    background-color: var(--border-color);
}

div.attribtable-resize-line-vert {
    width: 4px;
    top: 0;
    bottom: 0;
}

div.attribtable-resize-line-horiz {
    height: 4px;
    left: 0;
    right: 0;
}`, "",{"version":3,"sources":["webpack://./components/style/AttributeTableWidget.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,sCAAsC;IACtC,cAAc;IACd,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,UAAU;IACV,wCAAwC;IACxC,+BAA+B;IAC/B;kDAC8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,wCAAwC;IACxC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,mBAAmB;IACnB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;;;;;;IAOI,eAAe;IACf,QAAQ;IACR,sBAAsB;IACtB,uCAAuC;IACvC,SAAS;IACT,YAAY;AAChB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;IAGI,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,MAAM;IACN,SAAS;AACb;;AAEA;IACI,WAAW;IACX,OAAO;IACP,QAAQ;AACZ","sourcesContent":["div.AttributeTable {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    position: relative;\n}\n\ndiv.attribtable-overlay {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(200, 200, 200);\n    z-index: 4;\n}\n\ndiv.attribtable-overlay > div.spinner {\n    width: 4em;\n    height: 4em;\n    margin-right: 1em;\n}\n\ndiv.attribtable-toolbar {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.125em;\n}\n\ndiv.attribtable-toolbar > * {\n    margin: 0.125em;\n}\n\ndiv.attribtable-contents {\n    flex: 1 1 auto;\n    background-color: var(--list-bg-color);\n    overflow: auto;\n    border: 1px solid var(--border-color);\n    position: relative;\n}\n\ntable.attribtable-table {\n    min-width: 100%;\n}\n\ntable.attribtable-table th {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    padding: 0;\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    box-shadow: inset -1px 0 0 var(--border-color),\n                inset 0 -1px 0 var(--border-color);\n    overflow: hidden;\n}\n\ntable.attribtable-table th:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n    width: 2em;\n}\n\ntable.attribtable-table th > span {\n    margin: 0 0 -1px -1px;\n    padding: 0.25em;\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n\ntable.attribtable-table th > span > span.icon {\n    position: absolute;\n    right: 1px;\n    background-color: var(--button-bg-color);\n    flex: 0 0 auto;\n    margin-left: 0.5em;\n}\n\nspan.attribtable-table-headername {\n    flex: 1 1 auto;\n    text-align: left;\n    display: flex;\n    align-items: center;\n}\n\ntable.attribtable-table tr:nth-child(even) {\n    background-color: var(--list-item-bg-color-even);\n}\n\ntable.attribtable-table tr:hover:not(.row-disabled) {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\ntable.attribtable-table td:first-child {\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    align-items: center;\n    padding: 0.25em 0.5em;\n    background-clip: padding-box;\n    position: sticky;\n    left: 0;\n    z-index: 1;\n    width: 2.5em;\n}\n\nspan.attribtable-table-ldraghandle,\nspan.attribtable-table-rdraghandle {\n    touch-action: none;\n    display: block;\n    position: absolute;\n    width: 4px;\n    top: 0;\n    bottom: 0;\n    cursor: ew-resize;\n}\n\nspan.attribtable-table-ldraghandle {\n    left: -1px;\n}\n\nspan.attribtable-table-rdraghandle {\n    right: 0px;\n}\n\nspan.attribtable-table-tdraghandle,\nspan.attribtable-table-bdraghandle {\n    touch-action: none;\n    display: block;\n    position: absolute;\n    height: 4px;\n    left: 0;\n    right: 0;\n    cursor: ns-resize;\n}\n\nspan.attribtable-table-tdraghandle {\n    top: -1px;\n}\n\nspan.attribtable-table-bdraghandle {\n    bottom: 0px;\n}\n\ntable.attribtable-table {\n    table-layout: fixed;\n    width: 100%;\n}\n\ntable.attribtable-table td {\n    border: 1px solid var(--border-color);\n    text-align: center;\n    height: 2em;\n}\n\ntable.attribtable-table td:first-child {\n    border-left-width: 0;\n}\n\ntable.attribtable-table td > input:not([type=checkbox]),\ntable.attribtable-table td > select,\ntable.attribtable-table td > div.TextInput,\ntable.attribtable-table td > div.number-input,\ntable.attribtable-table td > div.edit-multi-select,\ntable.attribtable-table td > span.edit-upload-field,\ntable.attribtable-table td > span.edit-upload-field-input {\n    min-width: 100%;\n    width: 0;\n    border: none!important;\n    background-color: transparent!important;\n    margin: 0;\n    height: 100%;\n}\n\ntable.attribtable-table td > div.TextInput,\ntable.attribtable-table td > div.TextInput > pre {\n    min-height: 2em;\n}\n\ntable.attribtable-table tr.row-disabled td > *:disabled,\ntable.attribtable-table tr.row-disabled,\ntable.attribtable-table tr.row-disabled * {\n    color: var(--text-color-disabled);\n    cursor: not-allowed!important;\n}\n\ndiv.attribtable-footbar {\n    display: flex;\n    align-items: center;\n    margin: 0 -0.25em;\n    flex-wrap: wrap;\n}\n\ndiv.attribtable-footbar > div {\n    margin: 0.25em;\n}\n\ndiv.attribtable-filter {\n    flex: 1 1 auto;\n}\n\ndiv.attribtable-filter .attribtable-filter-value {\n    flex: 1 1 auto;\n    min-width: 5em;\n    max-width: 15em;\n}\n\nbody.ewresizing, body.ewresizing * {\n    cursor: ew-resize!important;\n    user-select: none;\n}\n\nbody.nsresizing, body.nsresizing * {\n    cursor: ns-resize!important;\n    user-select: none;\n}\n\ndiv.attribtable-resize-line-vert,\ndiv.attribtable-resize-line-horiz {\n    position: absolute;\n    z-index: 2;\n    background-color: var(--border-color);\n}\n\ndiv.attribtable-resize-line-vert {\n    width: 4px;\n    top: 0;\n    bottom: 0;\n}\n\ndiv.attribtable-resize-line-horiz {\n    height: 4px;\n    left: 0;\n    right: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
